<template>
  <QualitativeAttributeEditor
    v-if="attributeStructure.type === AttributeStructureType.Qualitative"
    v-model="answer"
    :attribute-structure="attributeStructure"
    :study="study"
    :is-expanded="isExpanded"
    :is-review-read-only="isReviewReadOnly"
    :expansion-panel="expansionPanel"
  />
  <MedicalAlternativesAttributeEditor
    v-else-if="attributeStructure.type === AttributeStructureType.MedicalAlternatives"
    :attribute-structure="attributeStructure"
    :study="study"
    :is-expanded="isExpanded"
    :is-review-read-only="isReviewReadOnly"
    :expansion-panel="expansionPanel"
  />
  <StudyDesignAttributeEditor
    v-else-if="attributeStructure.type === AttributeStructureType.StudyDesign"
    :attribute-structure="attributeStructure"
    :study="study"
    :is-expanded="isExpanded"
    :is-review-read-only="isReviewReadOnly"
    :expansion-panel="expansionPanel"
  />
</template>

<script setup lang="ts">
import { ReviewItem } from "@core/domain/models/reviewItem.model";
import QualitativeAttributeEditor from "./QualitativeAttributeEditor.vue";
import MedicalAlternativesAttributeEditor from "./MedicalAlternativesAttributeEditor.vue";
import StudyDesignAttributeEditor from "./StudyDesignAttributeEditor.vue";
import { AttributeStructure } from "@core/domain/models/data-extraction-plan-attribute";
import { AttributeStructureType } from "@core/domain/types/attributeStructureType.type";

withDefaults(
  defineProps<{
    attributeStructure: AttributeStructure;
    study: ReviewItem;
    isExpanded: boolean;
    isReviewReadOnly?: boolean;
    expansionPanel?: any;
  }>(),
  {
    isReviewReadOnly: false,
  },
);

const answer = defineModel<string>();
</script>
